import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Step1BusinessActivity } from "./step1-business-activity/step1-business-activity";
import { Step2BusinessAddress } from "./step2-business-address/step2-business-address";
import { Step3KeyPersonnelDetails } from "./step3-key-personnel-details/step3-key-personnel-details";  
@Component({
  selector: 'app-step3-business-profile',
  imports: [CommonModule, Step1BusinessActivity, Step2BusinessAddress, Step3KeyPersonnelDetails],
  templateUrl: './step3-business-profile.html',
  styleUrl: './step3-business-profile.css'
})
export class Step3BusinessProfile {
 @Input() data: any;
  @Input() onboardingStep!: number;
  @Input() onboardingSubStep!: number;
  @Output() dataChange = new EventEmitter<any>();
  @Output() next = new EventEmitter<void>();
  @Output() prev = new EventEmitter<void>();

  businessProfileForm: any = {
    businessActivity: {},
    businessAddress: {},
    keyPersonnelDetails: {}
  };

  constructor() {
  }

  onNextClick() {
    this.next.emit();
  }

  onPrevClick() {
    this.prev.emit();
  }
}
